import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatTwitterTime } from '../../helpers/momentHelpers.js'; // import { archiveConversation } from 'redux/modules/messageCenter';

import PostPreview from './PostPreview';
import { FBBody, FBComment, FBHeader, FBReplyField, InstagramComment, InstagramReplyField, TwitterComment, TwitterReplyField } from 'components/SocialPreviews';
import { SecondaryButton, Video } from 'components';
import * as styles from './Conversation.scss';

var Conversation = /*#__PURE__*/function (_Component) {
  _inherits(Conversation, _Component);

  var _super = _createSuper(Conversation);

  function Conversation() {
    var _this;

    _classCallCheck(this, Conversation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      visibleReplyFields: {}
    });

    _defineProperty(_assertThisInitialized(_this), "handleDelete", function () {// this.props.archiveConversation(this.props.organization.id, this.props.thread.id);
    });

    _defineProperty(_assertThisInitialized(_this), "renderFBDM", function (msg, parentEntity, index) {
      var owner = msg.authorPlatformId !== parentEntity.facebookId;
      var alignSelf = owner ? 'flex-end' : 'flex-start';
      var backgroundColor = owner ? '#4080ff' : '#f1f0f0';
      var color = owner ? 'white' : 'black';

      if (msg.details && msg.details.message && msg.details.message.attachments) {
        var atts = msg.details.message.attachments;
        var images = atts.map(function (a, index) {
          if (a.type === 'image') {
            return /*#__PURE__*/React.createElement("img", {
              style: {
                alignSelf: alignSelf
              },
              src: a.payload.url,
              key: index
            });
          }

          return /*#__PURE__*/React.createElement("div", {
            key: index
          });
        });

        if (msg.text) {
          images = [/*#__PURE__*/React.createElement("h3", {
            className: styles.dmItem,
            key: index,
            style: {
              alignSelf: alignSelf,
              backgroundColor: backgroundColor,
              color: color
            }
          }, msg.text)].concat(_toConsumableArray(images));
        }

        return images;
      }

      return /*#__PURE__*/React.createElement("h3", {
        className: styles.dmItem,
        key: index,
        style: {
          alignSelf: alignSelf,
          backgroundColor: backgroundColor,
          color: color
        }
      }, msg.text);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTwitterDM", function (msg, parentEntity, index) {
      console.log(msg);
      var mediaObjects = msg.details.entities.media && msg.details.entities.media.length ? msg.details.entities.media : null;
      var owner = msg.authorPlatformId !== parentEntity.twitterId;
      var alignSelf = owner ? 'flex-end' : 'flex-start';
      var backgroundColor = owner ? '#1da1f2' : '#e6ecf0';
      var color = owner ? 'white' : 'black';

      if (mediaObjects) {
        backgroundColor = 'transparent';
        var borderRadius = owner ? '14px 14px 0 14px' : '14px 14px 14px 0';
        var tweetMessage = msg.text;
        var mediaComponents = [];
        mediaObjects.forEach(function (obj) {
          var url = tweetMessage.slice(obj.indices[0], obj.indices[1]);
          tweetMessage = tweetMessage.replace(url, '');
          var mediaFullLink = obj.video_info && obj.video_info.variants && obj.video_info.variants.length ? obj.video_info.variants[0].url : obj.media_url_https;
          console.log(mediaFullLink);
          mediaComponents.push(function () {
            return mediaFullLink.indexOf('.mp4') !== -1 ? /*#__PURE__*/React.createElement(Video, {
              src: mediaFullLink,
              autoPlay: obj.type === 'animated_gif',
              controls: obj.type !== 'animated_gif',
              loop: true,
              muted: true,
              width: obj.sizes.small.w,
              style: {
                borderRadius: borderRadius
              }
            }) : /*#__PURE__*/React.createElement("img", {
              style: {
                alignSelf: alignSelf,
                borderRadius: borderRadius
              },
              src: mediaFullLink
            });
          });
        });
        return /*#__PURE__*/React.createElement("h3", {
          className: styles.dmItem,
          key: index,
          style: {
            alignSelf: alignSelf,
            backgroundColor: backgroundColor,
            color: color
          }
        }, tweetMessage, mediaComponents.map(function (c) {
          return c();
        }));
      }

      return /*#__PURE__*/React.createElement("h3", {
        className: styles.dmItem,
        key: index,
        style: {
          alignSelf: alignSelf,
          backgroundColor: backgroundColor,
          color: color
        }
      }, msg.text);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInstagramComment", function (msg, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.commentWrap
      }, /*#__PURE__*/React.createElement(InstagramComment, {
        comment: msg,
        key: index
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTwitterComment", function (msg, index) {
      console.log('renderTwitterComment()');
      console.log(msg);
      var avatarUrl = msg.authorAvatarUrl;
      var conversationId = msg.ConversationId;
      var handle = "@".concat(msg.details.user.screen_name);
      var datetime = formatTwitterTime(msg.details.created_at);
      var image = msg.details.entities.hasOwnProperty('media') ? msg.details.entities.media[0].media_url_https : false;
      var numLikes = msg.details.favorite_count;
      var numReplies = 49;
      var numRetweets = msg.details.retweet_count;
      var parentHandle = "@".concat(msg.details.in_reply_to_screen_name);
      var text = msg.details.text;
      var username = msg.details.user.name;
      var tweetId = msg.details.id_str;
      return /*#__PURE__*/React.createElement(TwitterComment, {
        avatarUrl: avatarUrl,
        conversationId: conversationId,
        handle: handle,
        datetime: datetime,
        image: image,
        numLikes: numLikes,
        numReplies: numReplies,
        numRetweets: numRetweets,
        parentHandle: parentHandle,
        text: text,
        tweetId: tweetId,
        username: username,
        key: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFacebookPagePost", function (conversation) {
      var hash = global.window ? global.window.location.hash : null;

      var renderCommentChain = function renderCommentChain(root) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return root && root.comments ? root.comments.map(function (comment) {
          var isReply = parent && parent.facebookId && parent.facebookId !== conversation.Subject.facebookId;
          var isFocused = "#comment_".concat(comment.facebookId) === hash;
          return [/*#__PURE__*/React.createElement(FBComment, {
            isFocused: isFocused,
            handleReaction: _this.props.handleReaction,
            handleClearReaction: _this.props.handleClearReaction,
            creatingComment: _this.props.creatingComment,
            orgSocialAccounts: _this.props.orgSocialAccounts,
            togglePostLike: _this.props.handlePostToggleLike,
            key: comment.id,
            comment: _objectSpread(_objectSpread({}, comment), {}, {
              id: comment.id,
              ConversationId: conversation.id,
              authorPlatformId: comment.details.from.id,
              authorName: comment.details.from.name,
              authorAvatarUrl: comment.details.from.picture ? comment.details.from.picture.data.url : '',
              platformCreatedAt: comment.platformCreatedAt,
              details: _objectSpread({}, comment.details),
              text: comment.details.message
            }),
            isReply: isReply,
            style: _objectSpread(_objectSpread({
              opacity: 1
            }, isReply ? {
              paddingLeft: 25
            } : {}), {}, {
              paddingTop: 5,
              borderRadius: 16,
              paddingLeft: 5,
              paddingRight: 5,
              paddingBottom: 5
            }),
            conversationId: parent ? parent.id : null,
            parent: parent ? parent.id : null,
            onHandleReply: function onHandleReply(comment) {
              _this.setState({
                visibleReplyFields: _objectSpread(_objectSpread({}, _this.state.visibleReplyFields), {}, _defineProperty({}, "".concat(comment.parentObjectId !== conversation.Subject.facebookId ? comment.parentObjectId : comment.facebookId), true))
              });
            }
          })].concat(_toConsumableArray(comment.comments ? renderCommentChain(comment, comment) : []), [!isReply ? /*#__PURE__*/React.createElement(FBReplyField, {
            key: "".concat(comment.facebookId, "_replyField"),
            orgSocialAccounts: _this.props.orgSocialAccounts,
            style: {
              marginBottom: 20
            },
            submitComment: _this.props.handleSubmitComment(comment.id),
            isReply: true,
            visible: _this.state.visibleReplyFields["".concat(comment.facebookId)] === true,
            creatingComment: _this.props.creatingComment,
            ref: _this.props.registerRef(comment.facebookId)
          }) : null]);
        }) : [];
      };

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostPreview, {
        type: "FACEBOOK_PAGE_POST",
        post: conversation.Subject
      }), /*#__PURE__*/React.createElement(FBReplyField, {
        orgSocialAccounts: _this.props.orgSocialAccounts,
        style: {
          marginBottom: 20
        },
        submitComment: _this.props.handleSubmitComment(conversation.Subject.id),
        visible: true,
        creatingComment: _this.props.creatingComment,
        ref: _this.props.registerRef(conversation.Subject.facebookId)
      }), /*#__PURE__*/React.createElement("div", null, renderCommentChain(conversation.Subject)));
    });

    return _this;
  }

  _createClass(Conversation, [{
    key: "render",
    value: function render() {
      var conversation = this.props.conversation;
      console.log('In render Conversation', conversation);

      if (!conversation || !conversation.Subject) {
        return /*#__PURE__*/React.createElement("div", null, "Oops! Something went wrong. Please try again later.");
      }

      if (conversation.Subject.hasOwnProperty('facebookId')) {
        switch (conversation.Subject.facebookObjectType) {
          case 'PAGE_POST':
          case 'PAGE_RATING':
            return this.renderFacebookPagePost(conversation);

          default:
            return /*#__PURE__*/React.createElement("div", null, "Unsupported object type");
        }
      }
    }
  }]);

  return Conversation;
}(Component);

export { Conversation as default };